<template>
  <div class="gif-exercise-container">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="GIF名称">
          <el-input
            v-model="searchForm.gifName"
            placeholder="请输入GIF名称"
            clearable
            @keyup.enter.native="handleSearch"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="分类">
          <el-select
            v-model="searchForm.categoryValue"
            placeholder="请选择分类"
            clearable
            style="width: 150px"
          >
            <el-option label="有氧" value="有氧"></el-option>
            <el-option label="热身" value="热身"></el-option>
            <el-option label="拉伸放松" value="拉伸放松"></el-option>
            <el-option label="健康改善" value="健康改善"></el-option>
            <el-option label="胸" value="胸"></el-option>
            <el-option label="背" value="背"></el-option>
            <el-option label="腿" value="腿"></el-option>
            <el-option label="臀" value="臀"></el-option>
            <el-option label="腹" value="腹"></el-option>
            <el-option label="肩" value="肩"></el-option>
            <el-option label="二头" value="二头"></el-option>
            <el-option label="三头" value="三头"></el-option>
            <el-option label="斜方肌" value="斜方肌"></el-option>
            <el-option label="小臂" value="小臂"></el-option>
            <el-option label="小腿" value="小腿"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="难度">
          <el-select
            v-model="searchForm.difficulty"
            placeholder="请选择难度"
            clearable
            style="width: 120px"
          >
            <el-option label="初级" :value="1"></el-option>
            <el-option label="中级" :value="2"></el-option>
            <el-option label="高级" :value="3"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="状态">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择状态"
            clearable
            style="width: 120px"
          >
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="handleAdd"
            v-permission="'btn:gif:add'"
          >添加GIF</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card">
      <el-table
        :data="gifList"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        
        <el-table-column label="预览" width="180" align="center">
          <template slot-scope="scope">
            <div style="display: flex; gap: 10px; justify-content: center;">
              <div>
                <div style="font-size: 12px; color: #999; margin-bottom: 4px;">缩略图</div>
                <el-image
                  v-if="scope.row.thumbnailUrl"
                  :src="scope.row.thumbnailUrl"
                  :preview-src-list="[scope.row.thumbnailUrl]"
                  fit="cover"
                  style="width: 60px; height: 60px; border-radius: 4px; cursor: pointer;"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <span v-else style="color: #999; font-size: 12px;">无</span>
              </div>
              <div>
                <div style="font-size: 12px; color: #999; margin-bottom: 4px;">大图</div>
                <el-image
                  v-if="scope.row.gifUrl"
                  :src="scope.row.gifUrl"
                  :preview-src-list="[scope.row.gifUrl]"
                  fit="cover"
                  style="width: 60px; height: 60px; border-radius: 4px; cursor: pointer;"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <span v-else style="color: #999; font-size: 12px;">无</span>
              </div>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="gifName" label="GIF名称" min-width="150"></el-table-column>
        
        <el-table-column prop="categoryValue" label="分类" width="120" align="center">
          <template slot-scope="scope">
            <el-tag size="small" type="primary">{{ scope.row.categoryValue }}</el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="description" label="描述" min-width="200" show-overflow-tooltip></el-table-column>
        
        <el-table-column label="难度" width="100" align="center">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="scope.row.difficulty === 1 ? 'success' : scope.row.difficulty === 2 ? 'warning' : 'danger'"
            >
              {{ scope.row.difficulty === 1 ? '初级' : scope.row.difficulty === 2 ? '中级' : '高级' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="duration" label="时长(秒)" width="100" align="center"></el-table-column>
        
        <el-table-column prop="sortOrder" label="排序" width="80" align="center"></el-table-column>
        
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(scope.row)"
              v-permission="'btn:gif:toggle'"
            ></el-switch>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              v-permission="'btn:gif:edit'"
            >编辑</el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              v-permission="'btn:gif:delete'"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum + 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;"
      ></el-pagination>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form
        :model="gifForm"
        :rules="gifFormRules"
        ref="gifFormRef"
        label-width="100px"
      >
        <el-form-item label="GIF名称" prop="gifName">
          <el-input v-model="gifForm.gifName" placeholder="请输入GIF名称"></el-input>
        </el-form-item>
        
        <el-form-item label="分类" prop="categoryValue">
          <el-select v-model="gifForm.categoryValue" placeholder="请选择分类" style="width: 100%">
            <el-option label="有氧" value="有氧"></el-option>
            <el-option label="热身" value="热身"></el-option>
            <el-option label="拉伸放松" value="拉伸放松"></el-option>
            <el-option label="健康改善" value="健康改善"></el-option>
            <el-option label="胸" value="胸"></el-option>
            <el-option label="背" value="背"></el-option>
            <el-option label="腿" value="腿"></el-option>
            <el-option label="臀" value="臀"></el-option>
            <el-option label="腹" value="腹"></el-option>
            <el-option label="肩" value="肩"></el-option>
            <el-option label="二头" value="二头"></el-option>
            <el-option label="三头" value="三头"></el-option>
            <el-option label="斜方肌" value="斜方肌"></el-option>
            <el-option label="小臂" value="小臂"></el-option>
            <el-option label="小腿" value="小腿"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="难度等级" prop="difficulty">
          <el-radio-group v-model="gifForm.difficulty">
            <el-radio :label="1">初级</el-radio>
            <el-radio :label="2">中级</el-radio>
            <el-radio :label="3">高级</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="时长(秒)">
          <el-input-number
            v-model="gifForm.duration"
            :min="0"
            :max="999"
            placeholder="请输入时长"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        
        <el-form-item label="排序">
          <el-input-number
            v-model="gifForm.sortOrder"
            :min="0"
            :max="9999"
            placeholder="数字越小越靠前"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        
        <el-form-item label="描述">
          <el-input
            v-model="gifForm.description"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入动作描述（最多500字）"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="缩略图" prop="thumbnailImage">
          <el-upload
            class="gif-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :http-request="handleThumbnailUpload"
            accept=".gif,.jpg,.jpeg,.png"
          >
            <img v-if="gifForm.thumbnailUrl" :src="gifForm.thumbnailUrl" class="gif-preview">
            <i v-else class="el-icon-plus gif-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">首页小图，支持GIF、JPG、PNG格式，建议大小不超过5MB</div>
        </el-form-item>
        
        <el-form-item label="GIF大图" prop="gifImage">
          <el-upload
            class="gif-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :http-request="handleUpload"
            accept=".gif,.jpg,.jpeg,.png"
          >
            <img v-if="gifForm.gifUrl" :src="gifForm.gifUrl" class="gif-preview">
            <i v-else class="el-icon-plus gif-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">点击放大图，支持GIF、JPG、PNG格式，建议大小不超过5MB</div>
        </el-form-item>
        
        <el-form-item label="状态">
          <el-switch
            v-model="gifForm.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'GifExercise',
  data() {
    return {
      // 搜索表单
      searchForm: {
        gifName: '',
        categoryValue: '',
        difficulty: null,
        status: null
      },
      
      // GIF列表
      gifList: [],
      loading: false,
      
      // 分页
      pagination: {
        pageNum: 0,
        pageSize: 20,
        total: 0
      },
      
      // 对话框
      dialogVisible: false,
      dialogTitle: '添加GIF',
      isEdit: false,
      submitLoading: false,
      
      // GIF表单
      gifForm: {
        id: null,
        gifName: '',
        categoryType: 1,
        categoryValue: '',
        description: '',
        duration: null,
        difficulty: 1,
        sortOrder: 0,
        status: 1,
        gifUrl: '',
        thumbnailUrl: '',
        base64Image: '',
        base64Thumbnail: ''
      },
      
      // 表单验证规则
      gifFormRules: {
        gifName: [
          { required: true, message: '请输入GIF名称', trigger: 'blur' }
        ],
        categoryValue: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ],
        difficulty: [
          { required: true, message: '请选择难度等级', trigger: 'change' }
        ]
      }
    };
  },
  
  mounted() {
    this.loadGifList();
  },
  
  methods: {
    // 加载GIF列表
    async loadGifList() {
      this.loading = true;
      try {
        const params = {
          ...this.searchForm,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        };
        
        const { data: res } = await this.$http.get('api/gif/list', { params });
        
        if (res.status === 0) {
          this.gifList = res.list || [];
          this.pagination.total = res.totalCount || 0;
        } else {
          this.$message.error(res.msg || '加载失败');
        }
      } catch (error) {
        console.error('加载GIF列表失败', error);
        this.$message.error('加载失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 0;
      this.loadGifList();
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        gifName: '',
        categoryValue: '',
        difficulty: null,
        status: null
      };
      this.pagination.pageNum = 0;
      this.loadGifList();
    },
    
    // 分页
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 0;
      this.loadGifList();
    },
    
    handleCurrentChange(val) {
      this.pagination.pageNum = val - 1;
      this.loadGifList();
    },
    
    // 添加
    handleAdd() {
      this.dialogTitle = '添加GIF';
      this.isEdit = false;
      this.dialogVisible = true;
    },
    
    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑GIF';
      this.isEdit = true;
      this.gifForm = {
        id: row.id,
        gifName: row.gifName,
        categoryType: row.categoryType || 1,
        categoryValue: row.categoryValue,
        description: row.description || '',
        duration: row.duration,
        difficulty: row.difficulty,
        sortOrder: row.sortOrder || 0,
        status: row.status,
        gifUrl: row.gifUrl,
        thumbnailUrl: row.thumbnailUrl,
        base64Image: '',
        base64Thumbnail: ''
      };
      this.dialogVisible = true;
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该GIF吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data: res } = await this.$http.post('api/gif/delete', { id: row.id });
          
          if (res.status === 0) {
            this.$message.success('删除成功');
            this.loadGifList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        } catch (error) {
          console.error('删除失败', error);
          this.$message.error('删除失败');
        }
      }).catch(() => {});
    },
    
    // 状态切换
    async handleStatusChange(row) {
      try {
        const { data: res } = await this.$http.post('api/gif/toggle-status', {
          id: row.id,
          status: row.status
        });
        
        if (res.status === 0) {
          this.$message.success('状态切换成功');
        } else {
          this.$message.error(res.msg || '状态切换失败');
          // 回滚状态
          row.status = row.status === 1 ? 0 : 1;
        }
      } catch (error) {
        console.error('状态切换失败', error);
        this.$message.error('状态切换失败');
        // 回滚状态
        row.status = row.status === 1 ? 0 : 1;
      }
    },
    
    // 图片上传前验证
    handleBeforeUpload(file) {
      const isValidType = ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      const isLt5M = file.size / 1024 / 1024 < 5;
      
      if (!isValidType) {
        this.$message.error('只支持GIF、JPG、PNG格式的图片');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB');
        return false;
      }
      return true;
    },
    
    // 自定义上传 - 缩略图
    handleThumbnailUpload(param) {
      const file = param.file;
      const reader = new FileReader();
      
      reader.onload = (e) => {
        // 获取Base64数据（去除前缀）
        const base64 = e.target.result.split(',')[1];
        this.gifForm.base64Thumbnail = base64;
        
        // 预览图片
        this.gifForm.thumbnailUrl = e.target.result;
        
        this.$message.success('缩略图已选择');
      };
      
      reader.readAsDataURL(file);
    },
    
    // 自定义上传 - 大图
    handleUpload(param) {
      const file = param.file;
      const reader = new FileReader();
      
      reader.onload = (e) => {
        // 获取Base64数据（去除前缀）
        const base64 = e.target.result.split(',')[1];
        this.gifForm.base64Image = base64;
        
        // 预览图片
        this.gifForm.gifUrl = e.target.result;
        
        this.$message.success('GIF大图已选择');
      };
      
      reader.readAsDataURL(file);
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.gifFormRef.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        
        // 验证图片
        if (!this.isEdit && !this.gifForm.base64Image) {
          this.$message.error('请上传GIF大图');
          return;
        }
        
        if (!this.isEdit && !this.gifForm.base64Thumbnail) {
          this.$message.error('请上传缩略图');
          return;
        }
        
        this.submitLoading = true;
        try {
          const url = this.isEdit ? 'api/gif/update' : 'api/gif/add';
          const { data: res } = await this.$http.post(url, this.gifForm);
          
          if (res.status === 0) {
            this.$message.success(this.isEdit ? '更新成功' : '添加成功');
            this.dialogVisible = false;
            this.loadGifList();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        } catch (error) {
          console.error('提交失败', error);
          this.$message.error('操作失败');
        } finally {
          this.submitLoading = false;
        }
      });
    },
    
    // 对话框关闭
    handleDialogClose() {
      this.$refs.gifFormRef.resetFields();
      this.gifForm = {
        id: null,
        gifName: '',
        categoryType: 1,
        categoryValue: '',
        description: '',
        duration: null,
        difficulty: 1,
        sortOrder: 0,
        status: 1,
        gifUrl: '',
        thumbnailUrl: '',
        base64Image: '',
        base64Thumbnail: ''
      };
    }
  }
};
</script>

<style scoped>
.gif-exercise-container {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 0;
}

.table-card {
  margin-top: 20px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

/* 图片上传样式 */
.gif-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.gif-uploader >>> .el-upload:hover {
  border-color: #409EFF;
}

.gif-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  display: block;
}

.gif-preview {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}
</style>
